import { Calendar, Hospital, DocumentText1, Logout, ClipboardText, Box1, ProfileCircle, Moneys } from "iconsax-react";

export const REQUEST_TYPE_ICON_MAP: Record<string, React.ComponentType<{ size: number; color: string }>> = {
  annual_leave: Calendar,
  medical_leave: Hospital,
  unpaid_leave: Calendar,
  amendment: DocumentText1,
  resignation: Logout,
  completion_act: ClipboardText,
  unit_request: Box1,
  data_change_request: ProfileCircle,
  advance: Moneys,
};
